import gsap from 'gsap';
import shouldAnimate from '../lib/ReducedMotion';

const INITIAL_DELAY = 0.5; // wait before the first text animates in
const FADE_IN = 2.0;    // duration of each text fading in
const FADE_OUT = 0.6;   // duration of each text fading out
const HOLD = 1.5;       // how long a text stays fully visible before the next
const RISE = 32;        // px each text travels upwards while fading in
const GAP = 0.3;        // seconds between one text fading out and the next fading in

export default el => {
    // The stacked hero texts (direct children — see the grid stack in markup)
    const texts = Array.from(el.children);

    let tl = null;

    const init = () => {
        if (!texts.length) {
            return;
        }

        const last = texts[texts.length - 1];

        // No animation (reduced motion, or only one text): just show the final one
        if (!shouldAnimate() || texts.length === 1) {
            gsap.set(texts, { opacity: 0 });
            gsap.set(last, { opacity: 1, y: 0 });
            return;
        }

        // Start hidden and nudged down, so each rises softly into place
        gsap.set(texts, { opacity: 0, y: RISE });

        // Each text fades up into view, holds, then fades out before the next
        // fades in — ending on the last, which stays. No repeat, so it doesn't loop.
        tl = gsap.timeline({ delay: INITIAL_DELAY });

        texts.forEach((text, i) => {
            const isLast = i === texts.length - 1;

            // First text starts right away; the rest wait a short gap after the
            // previous one has faded out
            tl.to(text, { duration: FADE_IN, opacity: 1, y: 0, ease: 'quart.out' }, i === 0 ? 0 : `+=${GAP}`);

            if (!isLast) {
                tl.to(text, { duration: FADE_OUT, opacity: 0, ease: 'sine.in' }, `+=${HOLD}`);
            }
        });
    };

    const destroy = () => {
        if (tl) {
            tl.kill();
            tl = null;
        }
        gsap.killTweensOf(texts);
    };

    return {
        init,
        destroy
    };
};
